import React from 'react';
import { Link } from 'react-router-dom';
import '../../components/Navigation.css';
import './scorekeeping.css';

/**
 * The header on pages a guest can reach.
 *
 * Shown to guests only. A signed-in member already has the application's own
 * header above the page, and two brand bars stacked is worse than none.
 *
 * It is built on the application header's own classes rather than a lookalike,
 * so the logo size, the wordmark size, the bar height and the colours cannot
 * drift apart from it. A guest and a member standing next to each other should
 * not be able to tell they are looking at two different pieces of code. Only
 * three things differ, and each is a thing a guest genuinely does not have: no
 * menu, no notification bell, and a way to sign in.
 *
 * It also solves something the older public pages do not: a guest standing at a
 * machine has nowhere to sign in from. The existing public machine page puts the
 * logo in a footer and offers no route in at all.
 *
 * Deliberately not yet used by the login screen, the older public machine page
 * or the PinGolf season page. Those three each have their own treatment and work
 * today; making the club's public face consistent is a decision to take with
 * them side by side, not a side effect of this project.
 */
function PublicHeader({ signInRedirect }) {
  return (
    <header className="mobile-header-bar sk-publicbar">
      {/* Balances the sign-in link so the branding sits on the centre line,
          the way the menu button and the bell balance it for a member. */}
      <span className="sk-publicbar__spacer" aria-hidden="true" />

      <Link className="mobile-branding sk-publicbar__brand" to="/">
        <img src="/logo.png" alt="Capital Pinball" className="mobile-logo" />
        <span className="mobile-app-title">Capital Pinball</span>
      </Link>

      <Link
        className="sk-publicbar__signin"
        to={`/login${signInRedirect ? `?redirect=${encodeURIComponent(signInRedirect)}` : ''}`}
      >
        Sign in
      </Link>
    </header>
  );
}

export default PublicHeader;
